<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PgNZea/tc-custom/9780312274177.jpg?1737748002226" alt="This image is the cover for the book Sex and Shopping: The Confessions of a Nice Jewish Girl"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sex and Shopping: The Confessions of a Nice Jewish Girl
      </h1>
      <p class="bookDescription body article font2">
        <p>Dear Reader, <br/><br/>As I was about to start my eleventh novel, I abruptly realized that I was making a huge mistake. On the verge of launching into the imagined world of a twenty-eight-year-old, I felt an intense need to tell another story, the story of a woman I know through and through...a woman with more wealth of experience, a woman who's seen more real glamour, known more fascinating people, lived in a world of more sophistication, and arrived at more hard-won maturity than that twenty-eight-year-old could hope for---in short, my own story. I've tried to remain as unknowable as possible, the better to let my heroines hold the stage, but now I was ready to tell the truth about myself, with no holding back.<br/><br/> I've had a different life from that of the majority of women of my generation and background. While I seemed like another "nice Jewish girl," underneath that convenient cover I'd traveled my own, inner-directed path and had many a spicy and secret adventure. I grew up in a complicated tangle of privilege, family problems, and tormented teenaged sexuality. After a riotous education at Wellesley, my life was turned upside down by a glorious year in Paris, marked by an intense but ill-starred romance. I spent the next half-decade in New York, sowing lighthearted wild oats until I finally met my true love, to whom I've been married for forty-six years.<br/><br/>When I was fifty I had an utterly unexpected, almost unbelievable success as a number-one bestselling novelist that has continued for book after book. Challenging, lucky, exciting, and often devastatingly askew, my life seems to have been lived under a wild and antic star.<br/><br/>I've had as much amazing fun as my heroines, and here's the book to prove it. <br/><br/><i>Judith Krantz</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judith Krantz
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16785e28